import { render, staticRenderFns } from "./LangModal.vue?vue&type=template&id=85b6f834&scoped=true"
import script from "./LangModal.vue?vue&type=script&lang=js"
export * from "./LangModal.vue?vue&type=script&lang=js"
import style0 from "./LangModal.vue?vue&type=style&index=0&id=85b6f834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b6f834",
  null
  
)

export default component.exports